import React from 'react';

export default function Footer(){
    return (
        <footer className='text-center py-6 bg-slate-100'>
        <h4 className='font-bold'>Project done by Sarah Abou Dalal</h4>
        <a className='mx-4 underline' href='https://github.com/sarahaboudalal'>GitHub</a>
        <a className='mx-4 underline' href='https://www.linkedin.com/in/sarah-abou-dalal-977891250/'>LinkedIn</a>
        </footer>
    )
}
